var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-widget"},[_c('h3',{staticClass:"sidebar-title"},[_vm._v(_vm._s(_vm.blogSidebar.CategoriesTitle))]),_c('ul',{staticClass:"sidebar-list"},[_c('li',[_c('router-link',{attrs:{"to":{
            path: '/blog',
          }}},[_vm._v("همه")])],1),_vm._l((_vm.blogSidebar),function(category){return _c('li',{key:category.id},[_c('router-link',{attrs:{"to":{
            path: '/blog/' + category.slug,
          }}},[_vm._v(_vm._s(category.name))])],1)})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }